module.exports = __webpack_public_path__ + "static/media/Arya Stark.bcc4f2ee.jpg";